import { db } from '../firebase';
import { collection, addDoc, doc, setDoc, serverTimestamp } from 'firebase/firestore';

export const migrateLocalToCloud = async (user, onProgress) => {
    const userId = user.uid;
    const localDataRaw = localStorage.getItem('football_playbook_data');
    if (!localDataRaw) {
        throw new Error("No local data found to migrate.");
    }

    const localData = JSON.parse(localDataRaw);
    let totalPlays = 0;
    let migratedPlaysCount = 0;

    // Count total plays first for progress tracking
    Object.values(localData).forEach(team => {
        Object.values(team.playbooks || {}).forEach(pb => {
            totalPlays += Object.keys(pb.plays || {}).length;
        });
    });

    if (totalPlays === 0) {
        throw new Error("Local portfolio is empty.");
    }

    // Process each team and playbook
    for (const [teamName, teamData] of Object.entries(localData)) {
        for (const [pbName, pbData] of Object.entries(teamData.playbooks || {})) {
            const playEntries = Object.entries(pbData.plays || {});
            const playCount = playEntries.length;

            // Create a cloud playbook
            const pbRef = await addDoc(collection(db, 'playbooks'), {
                name: `${pbName} (${teamName} Import)`,
                ownerId: userId,
                collaboratorIds: [userId],
                collaborators: {
                    [userId]: {
                        role: 'owner',
                        email: user.email,
                        displayName: user.displayName
                    }
                },
                playCount: playCount,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
                isImported: true,
                profile: pbData.profile || { level: 'HS', format: '6v6' }
            });

            // Add plays to this playbook
            for (let i = 0; i < playEntries.length; i++) {
                const [playName, playData] = playEntries[i];
                const playRef = doc(collection(db, 'playbooks', pbRef.id, 'plays'));

                await setDoc(playRef, {
                    ...playData,
                    id: playRef.id,
                    playbookId: pbRef.id,
                    playName: playName,
                    order: playData.order ?? i,
                    rating: playData.rating ?? 0,
                    createdAt: serverTimestamp(),
                    updatedAt: serverTimestamp()
                });

                migratedPlaysCount++;
                if (onProgress) onProgress(migratedPlaysCount, totalPlays);
            }
        }
    }

    return { totalPlays, migratedPlays: migratedPlaysCount };
};
